import type { ColorKey } from '@/types/tailwind'
import { bgColor500p25, textColor500 } from '@/globals/tailwind.ts'
import moment from 'moment'

export const formatNote = (text: string, color: ColorKey = 'blue', link: boolean = false) => {
  let result = text

  if (text) {
    // format tanggal
    result = text.replace(
      /(\d{2}\/\d{2}\/\d{4})/g,
      '<small class="text-stone-500 bg-stone-500/25 px-1 py-0.5 rounded-md font-mono">$1</small>',
    )

    // format part
    if (link) {
      result = result.replace(
        /\[\[([^\]]+)\]\]/g,
        '<a href="/p/part?search=$1" target="_blank" class="text-[.6rem] ' +
          textColor500[color] +
          ' ' +
          bgColor500p25[color] +
          ' px-1 py-0.5 rounded-md hover:underline whitespace-nowrap cursor-pointer font-mono">$1</a>',
      )
    } else {
      // result = result.replace(/\[\[([^\]]+)\]\]/g, '<small class="text-'+color+'-500 bg-'+color+'-500/25 px-1 py-0.5 rounded-md whitespace-nowrap">$1</small>')
      result = result.replace(
        /\[\[([^\]]+)\]\]/g,
        '<small class="' +
          textColor500[color] +
          ' ' +
          bgColor500p25[color] +
          ' px-1 py-0.5 rounded-md whitespace-nowrap font-mono">$1</small>',
      )
    }
  }
  return result
}

export const formatDateInput = (text: string, withTime: boolean = false) => {
  if (!text?.trim())
    return withTime ? moment().format('DD/MM/YYYY HH.mm') : moment().format('DD/MM/YYYY')

  return withTime
    ? moment(text, 'DD/MM/YYYY HH.mm').format('DD/MM/YYYY HH.mm')
    : moment(text, 'DD/MM/YYYY').format('DD/MM/YYYY')
}

export const formatPhoneNumber = (val: string) => {
  let number = val
  if (val) {
    // Menghilangkan semua karakter selain angka
    number = number.replace(/\D/g, '')
    // Menghilangkan kode negara jika ada (+62 atau 62)
    number = number.replace(/^(\+?62|0)/, '')

    if (number.charAt(0) !== '0') {
      if (number.charAt(0) === '8') number = '0' + number
    }
  }
  return number
}
